<div class="d-flex">
  <div class="col-md-1 col-4 card-header pointer my-auto">
    <img class="profile-img" src="assets/img/{{ isCollapsed ? 'profile-inactive.svg' : 'profile-active.svg' }}">
  </div>
  <div (click)="isCollapsed = !isCollapsed" tabindex="0" class="card-header pointer col-md my-auto"
    [attr.aria-expanded]="!isCollapsed" [attr.aria-controls]="'collapse-' + key">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="card-title mb-0">
        {{ getLabel }}
      </h3>
      <i class="icon-chevron-{{ isCollapsed ? 'down' : 'up' }}"></i>
    </div>
    <div class="d-flex mt-2 font-weight-bold">
      {{ !!to?.subText ? props.subText : null }}
    </div>
  </div>
</div>
<div class="d-flex">
  <div class="col-md-1 section-border d-print-none"></div>
  <div id="collapse-{{ key }}" [ngbCollapse]="isCollapsed">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>